module.exports = __webpack_public_path__ + "img/c1.85c2361c.png";